import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//import 'core-js';
//import "core-js/stable";
//import "regenerator-runtime/runtime";
// import 'babel/polyfill';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import allReducers from './reducers'; // No need to specify index.js explicitly
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { HashRouter } from 'react-router-dom';

import { Spinner, Box } from '@blueprint/ui';

import './index.css';

export const store = createStore(allReducers, applyMiddleware(thunk));

store.subscribe(() => {
    console.log('Global state from subscribe', store.getState());
});

ReactDOM.render(
    <Suspense
        fallback={
            <Box display='flex' flexDirection='column' justifyContent='center' height='100vh'>
                <Box>
                    <Spinner variant='light.large' label='Loading' />
                </Box>
            </Box>
        }
    >
        <Provider store={store}>
            <HashRouter>
                <App />
            </HashRouter>
        </Provider>
    </Suspense>,
    document.getElementById('root')
);

if (process.env.NODE_ENV !== 'development') {
    console.log = () => {};
    console.error = () => {};
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
